import o from"./col";export{StyledCol}from"./col.styles";export default o;